import {Component, OnInit, ViewChild} from '@angular/core';
import {LayoutService} from "@app/core/services/layout.service";
import { ModalDirective } from 'ngx-bootstrap';
import { NotificationService, AuthService, GeocodeService } from '@app/core/services';
import { OrdersDAO } from '@app/features/orders/orders.dao';
import { ActivatedRoute } from '@app/../../node_modules/@angular/router';
import { FileUploadComponent } from '@app/file-upload/file-upload.component';
import { OfficeService } from '@app/core/services/office.service';
import COLORS from '@app/shared/lib/colors';

import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import {Observable,Subject, merge} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';


import { TaskService } from '@app/core/services/task.service';

import * as moment from 'moment';
import { UtilsService } from '@app/core/services/utils.service';
import { PriceService } from '@app/core/services/price.service';


declare var google;


@Component({
  selector: 'sa-request-dealer',
  templateUrl: './request-dealer.component.html',
  styleUrls: ['./request-dealer.component.scss']
})
export class RequestDealerComponent implements OnInit{
   
  map: any;

  @ViewChild('myModal') public myModal:ModalDirective;
  @ViewChild('modalCreateOrder') public modalCreateOrder:ModalDirective;
  @ViewChild('uploadComponent') public uploadComponent:FileUploadComponent;  
  @ViewChild('uploadComponent2') public uploadComponent2:FileUploadComponent;  

  onCompleteUploadObserver:any;
  request:any = {}

  office: any = {}

  offices: any = [];
  
  action:string='create';

  currentLocationMarker:any;
  
  url: Observable<string>;
  urlImg: string;


  
  
  location: any = {
    latitude: null,
    longitude: null,
    zoom: 15
  };

  public tab = "tab1";    //Tab seleccionado

  pointToMark: string = 'start';

  programmed : string = "false";
  messageProgrammed : string = "Arribar en";
  dateOrder: any = "";
  dateOrderMin: any = "";
  dateOrderMax: any = "";
  disabledDateOrder: boolean = true;

  model: any;

  @ViewChild('instance') instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => term === '' ? []
        : this.offices.filter(v => (this.utils.removeTildes(v.name)).toLowerCase().indexOf((this.utils.removeTildes(term)).toLowerCase()) > -1).slice(0, 10))
    );
  }

  formatter = (x: any) => {
    try{
      return x.shop.name + ' ' + x.alias;
    }catch(error){
      return x;
    }
    
  };
  
  constructor(
    private dao: OrdersDAO,
    private ns: NotificationService,
    public auth: AuthService,
    private route: ActivatedRoute,
    private officeService: OfficeService,
    private geocodeService: GeocodeService,
    private priceService: PriceService,
    private utils: UtilsService
  ) {
	  this.programmed = "false";
  }

  async ngOnInit(){
    let officeBase = await this.officeService.getOfficeById('base');
    this.auth.setOfficeBase(officeBase);
    this.getUserLocation();  
    this.programmed = "false";  
    this.getUserLocation();    
    
    this.officeService.getOffices().subscribe(data => {
      this.offices = data;  
      for(let doc of this.offices) {
        doc.name = doc.shop.name + ' ' + doc.alias;
      }
    });
  }

  selectItem(e, type:string){
    if(type==='start'){
      this.request.locationStart= {
        latitude: null,
        longitude: null
      };   
      this.request.locationStart.latitude = e.item.lat;
      this.request.locationStart.longitude = e.item.lng;
    }else{
      if(type==='delivery'){
        this.request.locationDelivery= {
          latitude: null,
          longitude: null
        };   
        this.request.locationDelivery.latitude = e.item.lat;
        this.request.locationDelivery.longitude = e.item.lng;
      }
    }
    this.map.setCenter({lat:e.item.lat, lng:e.item.lng});
    this.calculeDistance();
  }

  onMapReady(map: any) {    
    this.map = map;
    // Blue current location marker
    this.currentLocationMarker = new google.maps.Marker({
      zIndex: 10,
      map: this.map,
      title: 'Posición actual',
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: COLORS.blue,
        fillOpacity: 0.8,
        strokeColor: COLORS.red,
        strokeOpacity: 1,
        strokeWeight: 5
      }
    });

    this.getUserLocation();
  }

  init(): void {   
    this.uploadComponent.init(); 
    //this.uploadComponent.setRenderImg(true);
    //this.uploadComponent.setOnCompleteUploadFileListenner(this.onCompleteUploadObserver); 

    this.uploadComponent2.init(); 
    //this.uploadComponent2.setRenderImg(true);
    //this.uploadComponent2.setOnCompleteUploadFileListenner(this.onCompleteUploadObserver); 
  
    this.request = {
      path: 'files-orders', 
      type: 'office',
      time: 0,
      phone: '',
      clientName: '',
      purchasePrice: null,
      addressDelivery: '',
      addressStart: null,
      purchaseDelivery: null,
      products: '',
      imgAdjunt:null,
      attachments:[],
      locationDelivery: null,
      locationStart: null,
      
    };
  }  
  
  show(){    
    this.init();
    this.request.type = 'office';
    this.pointToMark = 'delivery';
    this.tab = 'tab1';
    this.office = this.auth.getOfficeSelected();
    this.myModal.show();
  } 

  showMCreateOrder(){
    this.init();
    this.request.type = 'base';
    this.pointToMark = 'start';
    this.tab = 'tab10';
    this.programmed = "false";
    this.office = this.auth.getOfficeBase();
    this.modalCreateOrder.show();
  }

  showMCreateOrderWhitDealer(dealer){
    this.init();
    this.request.type = 'base';
    this.pointToMark = 'start';
    this.tab = 'tab10';
    this.office = this.auth.getOfficeBase();
    this.modalCreateOrder.show();
  }

  radioChangeTime(aux: number, id){
    $('#knob'+id)
        .val(aux)
        .trigger('change');
    this.request.time=aux;
    if(this.programmed == 'false' && id==2){
      this.programmed = 'false';
      this.dateOrder = moment(new Date(Date.now() + this.minutes(aux))).format('YYYY-MM-DDThh:mm') ;
    }
  }

  changeTypeDelivery(programmed: boolean){
    if(!programmed){
      this.messageProgrammed = "Arribar en: (min)";
      this.dateOrder = moment(new Date(Date.now() + this.minutes(20))).format('YYYY-MM-DDThh:mm') ;
      this.disabledDateOrder = true;
    }else{
      this.radioChangeTime(20, 2);
      this.messageProgrammed = "Notificar antes de:";
      this.dateOrder = '';
      this.dateOrderMin = moment(new Date(Date.now() + this.minutes(20))).format('YYYY-MM-DDThh:mm') ;
      this.dateOrderMax = moment(new Date(Date.now() + this.minutes(60*24*7))).format('YYYY-MM-DDThh:mm') ;
      this.disabledDateOrder = false;
    }
  }

  private getUserLocation() {
    if (navigator.geolocation) {
       navigator.geolocation.getCurrentPosition(position => {
        this.location.latitude = position.coords.latitude;
        this.location.longitude = position.coords.longitude;
        try{
          if(google){
            var latlng = new google.maps.LatLng(this.location.latitude, this.location.longitude);
            this.currentLocationMarker.setPosition(latlng);
            }
        }catch(err){}
        
      });
    }
  }

  setLocationDelibery(event){
    this.request.locationDelivery.latitude = event.coords.lat;
    this.request.locationDelivery.longitude = event.coords.lng;
  }

  setLocation(event){ 
    if(this.pointToMark=='delivery'){  
      if(!this.request.locationDelivery){
        this.request.locationDelivery= {
          latitude: null,
          longitude: null
        };
      }  
      this.request.locationDelivery.latitude = event.coords.lat;
      this.request.locationDelivery.longitude = event.coords.lng;
      this.coordinatesToAddress("delivery",  this.request.locationDelivery);
    }else if(this.pointToMark=='start'){   
      if(!this.request.locationStart){
        this.request.locationStart= {
          latitude: null,
          longitude: null
        };
      } 
      this.request.locationStart.latitude = event.coords.lat;
      this.request.locationStart.longitude = event.coords.lng;
      this.coordinatesToAddress("start",  this.request.locationStart);
    }   
  }

  markLocation(type){
    this.pointToMark = type;
    if(type=='start'){
      this.request.locationStart=null;
      this.addressToCoordinates(type, this.request.addressStart);
    }if(type=='delivery'){
      this.request.locationDelivery=null;
      this.addressToCoordinates(type, this.request.addressDelivery);
    }
  }

  getFiles(){
  }

  minutes(v: number) {
    return v * 60 * 1000;
  }

  deleteAddress(type){
    if(type=='start'){
      this.request.locationStart=null;
      this.request.addressStart='';
    }if(type=='delivery'){
      this.request.locationDelivery=null;
      this.request.addressDelivery='';
    }
    this.calculeDistance();
  }

  addressToCoordinates(type:string, address) {
    if(address.indexOf('maps.google.com')>0 || address.indexOf('maps/\@') > 0){
      this.urlToAddress(address, type);
      return null;
    }

    if(type=='delivery'){
      this.request.locationDelivery= {
        latitude: null,
        longitude: null
      };
    }else{
      this.request.locationStart= {
        latitude: null,
        longitude: null
      };
    }
    this.geocodeService.geocodeAddress(address)
    .subscribe(
      location => {
        this.map.setCenter(new google.maps.LatLng(location.latitude, location.longitude));
        if(type=="delivery"){
          this.request.locationDelivery = location;          
        }else if(type=="start"){
          this.request.locationStart = location;
        }
        this.calculeDistance()
      }      
    );     
  }

  /**
   * Extrae desde la URL las coorddenas y establece un marcador , así tambén obtiene la
   * dirección a partir del las coordenadas
   * 
   * @param url Dirección URL de punto georefrenciado desde Whatsapp o google maps
   * @param type Refernecia a si es para marcar punto de inicio o de llegada
   */
  urlToAddress(url: string, type: string){
    url = url.replace('%2C', ',');
    let latitude = url.match(/q=(-?[\d\.]*)/);
    if(latitude===undefined || latitude===null)
      latitude = url.match(/\@(-?[\d\.]*)/);
    let longitude = url.match(/q=[-?\d\.]*\,([-?\d\.]*)/);
    if(longitude===undefined || longitude===null)
      longitude = url.match(/\@[-?\d\.]*\,([-?\d\.]*)/);

    const location = {
      latitude: Number(latitude[1]),
      longitude: Number(longitude[1])
    }

    this.map.setCenter(new google.maps.LatLng(location.latitude, location.longitude));
    if(type=="delivery"){
      this.request.locationDelivery = location;  
      this.request.addressDelivery = null;        
    }else if(type=="start"){
      this.request.locationStart = location;
      this.request.addressStart = null;
    }        

    this.coordinatesToAddress(type, location);
  }

  coordinatesToAddress(type:string, location){
    this.geocodeService.geocodeLatLng(location)
    .subscribe(
      address => {   
        if(address!==null){  
          address = address.replace(', Cuenca, Ecuador', '');   
          address = address.replace(', Ecuador', '');
          if(type=="delivery"){
            if(this.request.addressDelivery=='' || this.request.addressDelivery==null)
              this.request.addressDelivery = address;          
          }else if(type=="start"){
            if(this.request.addressStart=='' || this.request.addressStart==null){
              this.request.addressStart = address;
            }
              
          } 
          this.calculeDistance();       
        }
      }      
    );    
  }

  confirmRegisterRequest(id) {
    let time = $('#knob'+id).val();
	    if(time==0){
	      this.ns.alertError("No ha seleccionado el tiempo de llegada estimado");
	    }else if(this.request.locationStart==null && this.request.type=='base'){
	      this.ns.alertError("No ha marcado el punto de inicio de la carrera");
	    }else{
        this.ns.confirmDialogYesNo2("Confirmación de acción!", "Confirma el requerimiento de <b>1</b> motorizado, para dentro de <b>" + time + " minutos</b>.", this.registerRequest.bind(this, id));
      }
  }

  async registerRequest(id){
	  let time = $('#knob'+id).val();
	    if(time==0){
	      this.ns.alertError("No ha seleccionado el tiempo de llegada estimado");
	    }else if(this.request.locationStart==null && this.request.type=='base'){
	      this.ns.alertError("No ha marcado el punto de inicio de la carrera");
	    }else{
	      try{ 
          let user = this.auth.getUser();
          if(this.request.type == 'office'){
            this.request.attachments = this.uploadComponent.files;
          }else{
            this.request.attachments = this.uploadComponent2.files;
          }
          if(this.programmed=="true"){
            const notificationTime = time;
            let orderNumber = await this.dao.newRequestProgrammed(this.dateOrder, notificationTime, this.office, user, this.request, this.location);
            this.modalCreateOrder.hide();
            this.ns.alertOK("Se ha programado una carrera a nombre de <b>#"+this.request.clientName+"</b>");            
          }else{
            let orderNumber = await this.dao.newRequestDealer(time, this.office, user, this.request, this.location,this.urlImg);
            if(this.request.type == 'office'){
              this.myModal.hide();
              this.ns.alertOK("Su solicitud ha sido enviada con <b>"+orderNumber+"</b>");  
            }else{ 
              this.modalCreateOrder.hide();
              this.ns.alertOK("Se ha registrado una nueva carrera con <b>#"+orderNumber+"</b>");        
            }
          }

          
	      }catch(error){
	        this.ns.alertError(JSON.stringify(error));
	      }
	    }
    
  }

  priceAutomatic: boolean = true;
  linkDistanceTo = '';
  distanceLineal = null;
  priceLineal = null;

  onChangePriceAutomatic(){
    if(this.priceAutomatic){
      this.calculeDistance();
    }
  }

 
  calculeDistance(){
    
    if(this.request.locationDelivery && this.request.locationStart){
      const start = new google.maps.LatLng(this.request.locationStart.latitude, this.request.locationStart.longitude);
      const end = new google.maps.LatLng(this.request.locationDelivery.latitude, this.request.locationDelivery.longitude);
      
      this.distanceLineal = Number((google.maps.geometry.spherical.computeDistanceBetween(
        start, end)/1000).toFixed(2));

      this.request.distanceDelivery = this.distanceLineal;
      
      this.linkDistanceTo = "https://www.distance.to/"+this.request.locationStart.latitude+","+this.request.locationStart.longitude+"/"+this.request.locationDelivery.latitude+","+this.request.locationDelivery.longitude;
      
      this.priceLineal = Number(this.priceService.calculatePrice(this.distanceLineal));
      if(this.priceAutomatic)
        if(this.priceLineal==0){
          this.request.priceDelivery = '??';
        }else{
          this.request.priceDelivery = this.priceLineal;
        }
    }else{
      this.linkDistanceTo = '';
      this.distanceLineal = null;
      this.priceLineal = null;
    }
  }

}
